import C from "../../common/constantes"
import Sales from '../../../services/sales'
import Contract from '../../../services/contracts'

import messageDialog from '../../../components/message-dialog.vue';
import {EventBus} from '../../../event-bus'

export default {
  props: ['type', 'rodosol'],
  data() {
    return {
      loading: undefined,
      urlMoveCargo: undefined
    }
  },

  mounted(){
    this.geturlMoveCargo();
  },

  computed:{
    sameTax(){
      return this.newAhesionTaxMan == this.newVehicleTaxMan && this.newAhesionTaxAut == this.newVehicleTaxAut
    },
    newAhesionTaxCont(){
      return this.$store.getters.getNewAdhesionTax(C.PLAN_MAN);
    }
},

 methods: {
      async geturlMoveCargo() {
        try {
          Contract.getUrlMoveCargo().then(resp =>{
            console.log(resp, "Resposta da url");
            this.urlMoveCargo  = resp.url;
          })
        } catch (error) {
          console.error('Erro na requisição: ', error);
          alert('Erro na requisição: ' + error.message);
        }
      }
    }

}



// WEBPACK FOOTER //
// ./src/pages/external/plans/vpo.js